import { render, staticRenderFns } from "./ConfirmationTypeIcon.vue?vue&type=template&id=27fb7838&scoped=true"
import script from "./ConfirmationTypeIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmationTypeIcon.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ConfirmationTypeIcon.vue?vue&type=style&index=0&id=27fb7838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fb7838",
  null
  
)

export default component.exports